<template>
    <div class="workspaceInfo">
        <p class="selectedWorkspaceTitle">Selected Workspace</p>
        <hr>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "/src/assets/css/var.scss";
.workspaceInfo {
    display: flex;
    background-color: $back2;
    border-radius: 6px;
    padding: 16px;
    flex-direction: column;
}
</style>
